import Icon, { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

function EditSVG() {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.41999 18.579C1.28125 18.5788 1.14408 18.5497 1.0172 18.4936C0.890315 18.4374 0.7765 18.3555 0.68299 18.253C0.587788 18.1514 0.515143 18.0308 0.469818 17.8991C0.424493 17.7675 0.407513 17.6277 0.41999 17.489L0.66499 14.795L11.983 3.48103L15.52 7.01703L4.20499 18.33L1.51099 18.575C1.48074 18.5778 1.45037 18.5792 1.41999 18.579ZM16.226 6.31003L12.69 2.77403L14.811 0.653028C14.9039 0.560052 15.0142 0.486292 15.1355 0.435968C15.2569 0.385644 15.3871 0.359741 15.5185 0.359741C15.6499 0.359741 15.78 0.385644 15.9014 0.435968C16.0228 0.486292 16.1331 0.560052 16.226 0.653028L18.347 2.77403C18.44 2.8669 18.5137 2.97719 18.5641 3.09859C18.6144 3.21999 18.6403 3.35011 18.6403 3.48153C18.6403 3.61294 18.6144 3.74307 18.5641 3.86447C18.5137 3.98587 18.44 4.09615 18.347 4.18903L16.227 6.30903L16.226 6.31003Z"
        fill="#424242"
      />
    </svg>
  );
}

export function EditIcon(props: Partial<CustomIconComponentProps>) {
  return <Icon component={EditSVG} {...props} />;
}
